import React from 'react';
import { Form, Col } from 'react-bootstrap';
import { FastField } from 'formik';
import PropTypes from 'prop-types';
// import FormFeedback from './FormFeedback';
import { formLabel } from '~/utils/helpers';
import { Tooltip } from '~/components/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';

function FormRadio({ name, className, trueLabel, falseLabel, sm, tooltip, label }) {
    const labelForm = label || formLabel(name);

    return (
        <FastField name={name}>
            {({ field, form, meta }) => {
                const isValid = !meta.error;
                const isInvalid = meta.touched && !isValid;

                const commonProps = {
                    name: name,
                    type: 'radio',
                    label: 'Yes',
                    isInvalid: isInvalid,
                    onChange: (e) => {
                        form.setFieldValue(field.name, parseInt(e.target.value) === 1 ? true : false);
                    },
                };
                return (
                    <Col
                        sm={sm}
                        className={className}
                    >
                        <Form.Label
                            as="div"
                            className="d-flex"
                        >
                            {tooltip ? (
                                <>
                                    {labelForm}
                                    <Tooltip content={tooltip}>
                                        <FontAwesomeIcon
                                            icon={faCircleInfo}
                                            size="xs"
                                            className="fa-light fa-fw ml-1"
                                        />
                                    </Tooltip>
                                </>
                            ) : (
                                labelForm
                            )}
                        </Form.Label>

                        <Form.Check
                            {...commonProps}
                            label={trueLabel}
                            id={`${name}-${trueLabel}`}
                            value={1}
                            checked={meta.value === true || meta.value === 1 ? true : false}
                        />
                        <Form.Check
                            {...commonProps}
                            label={falseLabel}
                            id={`${name}-${falseLabel}`}
                            value={0}
                            checked={meta.value === false || meta.value === 0 ? true : false}
                        />
                        {/* <FormFeedback
                            isInvalid={isInvalid}
                            isValid={isValid}
                            errorMessage={getIn(form.errors, name)}
                            className={'col-sm-5'}
                        /> no need as error message will break UI when there is not enough space*/}
                    </Col>
                );
            }}
        </FastField>
    );
}

FormRadio.defaultProps = {
    className: '',
    trueLabel: 'Yes',
    falseLabel: 'No',
    sm: 2,
    tooltip: '',
    label: '',
};
FormRadio.propTypes = {
    name: PropTypes.string.isRequired,
    className: PropTypes.string,
    trueLabel: PropTypes.string,
    falseLabel: PropTypes.string,
    sm: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    tooltip: PropTypes.string,
    label: PropTypes.string,
};
export default FormRadio;
/**Note */
//need to wrap inside Form.Group to make the checkbox checked once. Ref:https://stackoverflow.com/questions/67677056/first-react-bootstrap-radio-button-click-is-not-triggering-touched-in-formik-f
